import type { Command } from './types';
import { useEditorStore } from '@/store/editorStore';

export const attachmentCommands: Command[] = [
  {
    id: 'attachments.open',
    label: 'Toggle Attachments',
    category: 'edit',
    canExecute: (ctx) => ctx.editorState.selectedNodeIds.length === 1,
    execute: (ctx) => {
      const store = useEditorStore.getState();
      const nodeId = ctx.editorState.selectedNodeIds[0];
      if (!nodeId) return;
      // Toggle: close if already open for this node, open otherwise
      if (store.attachmentPanelNodeId === nodeId) {
        store.closeAttachmentPanel();
      } else {
        store.openAttachmentPanel(nodeId);
      }
    },
  },
  {
    id: 'attachments.close',
    label: 'Close Attachments',
    category: 'edit',
    canExecute: () => useEditorStore.getState().attachmentPanelNodeId !== null,
    execute: () => {
      useEditorStore.getState().closeAttachmentPanel();
    },
  },
];
